import type { MainPoiCategory } from '$lib/components/pois/types';

// on mobile, we show 1 or 2 images depending on device width
// on desktop we show more images but preloading extras would result in mobile users getting worse perf
export const PREFETCH_IMAGES_COUNT = 2;

export const POIS_HRT: MainPoiCategory[] = ['ACCOMMODATION', 'RESTAURANT', 'TOURISM'];

export const POIS_HRT_TYPENAMES_LIST = ['AccommodationPOI', 'AccommodationMichelinPOI', 'RestaurantMichelinPOI', 'TourismPOI', 'RestaurantPOI'];
